{
  "steplist": "Λίστα βημάτων"
}
